import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styled from 'styled-components'
import { colors, mix } from 'styles'
import { isGold } from 'utils'
import { POLICY_IDS } from 'common/constants'
import { T } from 'components/Translations'
import { updatePhotoFilter, goToUpgrade } from 'store/actions'

const c1 = mix(0.33, colors.textMain, colors.mainBackground)
const c2 = mix(0.66, colors.textMain, colors.mainBackground)

export const StyledPhotofilter = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  position: relative;
  font-size: 1.1rem;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .r-group {
    line-height: 1;
    border-radius: 1rem;
    box-shadow: 0 0 0 0.1rem ${colors.textMain}; // using box-shadow instead of border due to backround glitches
    display: flex;
    overflow: hidden;
  }
  .r-option {
    cursor: pointer;
    position: relative;
    padding: 0.5em 0.5em 0.5em 1.5em;
    transition: 0.5s;
    &:first-child {
      padding-left: 1.2em;
    }
    &:last-child {
      padding-right: 1.2em;
    }
  }
  .r-1::before,
  .r-2::before {
    display: block;
    border: 1em solid transparent;
    border-right: none;
    content: '';
    position: absolute;
    right: -1em;
    top: 0;
    z-index: 1;
    transition: 0.5s;
  }
  .r-1 {
    background: ${c1};
    &::before {
      border-left-color: ${c1};
    }
  }
  .r-2::before {
    border-left-color: ${colors.mainBackground}; // for better animation when changing xxx => normal
  }
  .r-2.active {
    background: ${c2};
    color: ${colors.mainBackground};
    &::before {
      border-left-color: ${c2};
    }
  }
  .r-3.active {
    background: ${colors.textMain};
    color: ${colors.mainBackground};
  }

  .r-info {
    cursor: help;
    padding: 0.3em 0.5em;
    .r-question {
      background: ${c1};
      width: 1.7em;
      line-height: 1.7em;
      border-radius: 1em;
      text-align: center;
    }

    .r-description {
      position: absolute;
      pointer-events: none;
      opacity: 0;
      background: ${colors.highlight};
      color: ${colors.mainInverted};
      top: 100%;
      left: 0;
      right: 0;
      z-index: 8;
      padding: 1em;
      border-radius: 1em;
      transition: 0.5s;
      &::before {
        content: '';
        position: absolute;
        top: -2em;
        left: 50%;
        margin-left: -1em;
        border: 1em solid transparent;
        border-bottom-color: ${colors.highlight};
      }
    }
    &:hover .r-description {
      opacity: 1;
      transform: translate(0, 1em);
    }
  }
`

const xxxUpgrade = () => goToUpgrade(POLICY_IDS.XXX, null, 3)

const Photofilter = () => {
  const enabled = useSelector(s => s.flags.photofilter)
  const ratings = useSelector(s => s.registry.adultRatings)
  const myRating = useSelector(s => s.myProfile.adultRatingId)
  const upgraded = useSelector(s => isGold(s.myProfile))
  const dispatch = useDispatch()
  const setRating = id => dispatch(id > 2 && !upgraded ? xxxUpgrade() : updatePhotoFilter(id, { silent: true }))

  return (
    enabled && (
      <StyledPhotofilter>
        <div className="r-group">
          {ratings.map(({ id, name }) => (
            <div key={id} className={`r-option r-${id} ${myRating >= id && 'active'}`} onClick={() => setRating(id)}>
              {name}
            </div>
          ))}
        </div>

        <div className="r-info">
          <div className="r-question">?</div>
          <T as="div" className="r-description" label="filterHint|basicHTML" />
        </div>
      </StyledPhotofilter>
    )
  )
}

export default Photofilter
